import { FC, useEffect, useRef } from 'react'
import { HlsPlayer, HlsPlayerMethods } from './hls'
import { VideoPlayerProps } from '../../types/props/live'

export const LivePlayer: FC<VideoPlayerProps> = ({
  isPlaying = true,
  hlsUri,
  tankName = null,
  cameraPosition = null,
  latestGridKey: _latestGridKey,
  onClick,
  isOnHover,
  ...props
}) => {
  const playerRef = useRef<HlsPlayerMethods>(null)

  useEffect(() => {
    if (!isPlaying) playerRef.current?.pause()
    else playerRef.current?.play().catch(() => { })
  }, [isPlaying])

  return (
    <div
      className="relative justify-start overflow-hidden border-tdpldark border-1 w-full aspect-video"
      onClick={onClick}
      {...props}
    >
      <p
        className="absolute z-30 text-white bg-opacity-50 text-[1.25rem] font-bold hover:font-outline-4 m-3"
        style={{ textShadow: '-2px 0 #092028, 0 2px #092028, 2px 0 #092028, 0 -2px #092028' }}
      >
        {tankName === null
          ? ' '
          : `${tankName} ${cameraPosition ? cameraPosition.replace(/\b[a-z]/, (letter) => letter.toUpperCase()) : ''}`}
      </p>
      {hlsUri === null ? (
        <div className="relative w-full h-full bg-tdplindigo z-1 min-h-max" />
      ) : (
        <>
          {isOnHover ? (
            <div className="absolute z-30 w-full h-full bg-white bg-opacity-0 min-h-max hover:bg-opacity-50" />
          ) : null}

          <HlsPlayer
            ref={playerRef}
            src={hlsUri}
            autoPlay={isPlaying}
            controls={false}
            muted={true}
            playsInline={true}
            width="100%"
            height="100%"
            videoClassName="relative w-full h-full z-1"
            videoStyle={{
              objectFit: 'cover',
              aspectRatio: `16 / 9`,
            }}
          />
        </>
      )}
    </div>
  )
}
